<template>
  <v-container id="licensePlate" fluid tag="section">
    <v-row>
      <v-col cols="10">
        <v-row>
          <v-col cols="3">
            <v-row>
              <v-col cols="6">
                <v-menu :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="licensePlateData.startDate"
                      :label="
                        $t('start') + ' ' + $t('date').toLowerCase() + '*'
                      "
                      prepend-icon="mdi-calendar-range"
                      required
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="licensePlateData.startDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="6">
                <v-menu :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="licensePlateData.startTime"
                      :label="
                        $t('start') + ' ' + $t('time').toLowerCase() + '*'
                      "
                      prepend-icon="mdi-clock-time-three-outline"
                      required
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-model="licensePlateData.startTime"
                    use-seconds
                    scrollable
                    format="ampm"
                    ampm-in-title
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="3">
            <v-row>
              <v-col cols="6">
                <v-menu :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="licensePlateData.endDate"
                      :label="$t('end') + ' ' + $t('date').toLowerCase() + '*'"
                      prepend-icon="mdi-calendar-range"
                      required
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="licensePlateData.endDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col cols="6">
                <v-menu :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="licensePlateData.endTime"
                      :label="$t('end') + ' ' + $t('time').toLowerCase() + '*'"
                      prepend-icon="mdi-clock-time-three-outline"
                      required
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-model="licensePlateData.endTime"
                    use-seconds
                    scrollable
                    format="ampm"
                    ampm-in-title
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col cols="4">
                <v-combobox
                  v-model="licensePlateData.selectedCameras"
                  :search-input.sync="selectedCamerasInput"
                  :label="$t('camera') + '*'"
                  :items="cameraNameItems"
                  persistent-hint
                  multiple
                  small-chips
                >
                  <template v-slot:prepend-item>
                    <v-list-item ripple @click="toggleSelectAll">
                      <v-list-item-action>
                        <v-icon color="primary">{{ selectAllIcon }} </v-icon>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title
                          >{{ $t("select") }} {{ $t("all") }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>

                  <template
                    v-slot:selection="{ attrs, item, parent, selected }"
                  >
                    <v-chip v-bind="attrs" :input-value="selected" label>
                      <span class="pr-2 display-1">
                        {{ item }}
                      </span>
                      <v-icon @click="parent.selectItem(item)">
                        mdi-close-thick
                      </v-icon>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>

              <v-col cols="4">
                <v-combobox
                  v-model="licensePlateData.filterLicensePlates"
                  :search-input.sync="filterLicensePlateInput"
                  :label="$t('add') + ' ' + $t('licensePlate')"
                  :hint="$t('addChipHint')"
                  persistent-hint
                  multiple
                  small-chips
                >
                  <template
                    v-slot:selection="{ attrs, item, parent, selected }"
                  >
                    <v-chip v-bind="attrs" :input-value="selected" label>
                      <span class="pr-2 display-1">
                        {{ item }}
                      </span>
                      <v-icon @click="parent.selectItem(item)">
                        mdi-close-thick
                      </v-icon>
                    </v-chip>
                  </template>
                </v-combobox>
              </v-col>

              <v-col cols="4">
                <v-select
                  v-model="licensePlateData.listTypes"
                  :items="listTypeItems"
                  multiple
                  :label="$t('list_type')"
                  item-text="text"
                  item-value="value"
                >
                </v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-select
              v-model="licensePlateData.plateTypes"
              :items="plateTypeItems"
              multiple
              :label="$t('plate_type')"
              item-text="text"
              item-value="value"
            >
            </v-select>
          </v-col>

          <v-col>
            <v-text-field
              v-model="licensePlateData.area"
              :label="$t('area')"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="licensePlateData.chineseName"
              :label="$t('chinese') + ' ' + $t('name')"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="licensePlateData.englishName"
              :label="$t('english') + ' ' + $t('name')"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="licensePlateData.company"
              :label="$t('company')"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="licensePlateData.department"
              :label="$t('department')"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              v-model="licensePlateData.employeeNumber"
              :label="$t('employee') + ' ' + $t('number')"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="2">
        <v-row>
          <v-col cols="4">
            <v-btn color="primary" @click="resetLicensePlate()">
              {{ $t("reset") }}
            </v-btn>
          </v-col>

          <v-col>
            <v-btn
              color="primary"
              @click="
                searchLicensePlate(
                  licensePlateData.startDate,
                  licensePlateData.startTime,
                  licensePlateData.endDate,
                  licensePlateData.endTime
                )
              "
              >{{ $t("search") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-row>
          <v-list
            color="#EEEEEE"
            rounded
            style="max-height: 500px"
            class="overflow-y-auto"
          >
            <v-list-item-title class="text-h3">
              <v-row>
                <v-col cols="6">
                  {{ $t("licensePlate") }}

                  {{ $t("count") }} : {{ totalCount }}
                </v-col>

                <v-col v-if="licensePlateItems.length > 0" cols="6">
                  <v-btn @click="getLicensePlateRawImages(selected)">
                    {{ $t("download") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item-title>

            <v-list-item-group color="primary">
              <v-list-item v-if="licensePlateItems.length == 0">
                <v-col class="display-3">{{ $t("no-data-hint") }}</v-col>
              </v-list-item>

              <v-list-item
                v-else
                v-for="(licensePlateItem, idx) in licensePlateItems"
                :key="idx"
                @click="selectLicensePlate(licensePlateItem)"
              >
                <v-list-item-icon>
                  <v-checkbox
                    v-model="selected"
                    :value="licensePlateItem._id"
                    :key="licensePlateItem._id"
                  ></v-checkbox>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-row>
                    <v-col cols="8">
                      <GuardianSnapshot
                        :image="
                          'data:image/png;base64,' + licensePlateItem.snapshot
                        "
                        :fences="licensePlateItem.fences"
                        :objects="licensePlateItem.license_plates"
                        :max-height="300"
                        :max-width="300"
                      ></GuardianSnapshot>
                    </v-col>

                    <v-col cols="4">
                      <v-col cols="12">
                        {{ translateTime(licensePlateItem.timestamp) }}
                      </v-col>

                      <v-col cols="12">
                        <v-row
                          v-for="(
                            licensePlate, idx
                          ) in licensePlateItem.license_plates.slice(0, 3)"
                          :key="idx"
                        >
                          {{ licensePlate.number }}
                        </v-row>
                      </v-col>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-row>

        <v-row v-if="licensePlateItems.length > 0">
          <v-col>
            <v-pagination
              v-model.number="page"
              :length="pageCount"
              :total-visible="10"
            ></v-pagination>
          </v-col>
        </v-row>

        <v-row v-if="licensePlateItems.length > 0" justify="center">
          <v-col cols="8">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model.number="tpage"
                  type="number"
                  filled
                  dense
                  :rules="rules.tpage"
                ></v-text-field>
              </v-col>

              <v-col cols="6">
                <v-btn @click="gotoPage(tpage)">{{ $t("goto") }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="8">
        <v-row>
          <LicensePlateItem
            v-if="selected_licensePlate != null"
            :licensePlates="selected_licensePlate"
          ></LicensePlateItem>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import LicensePlateItem from "@/components/recognition/LicensePlateItem.vue";
import GuardianSnapshot from "@/components/guardian/GuardianSnapshot";
import { getInferenceCameras } from "@/endpoint/inferenceCamera";
import { getLicensePlateRawImages } from "@/endpoint/licensePlate.js";
import { random, translateTime } from "@/plugins/util";

export default {
  name: "licensePlate",
  components: { LicensePlateItem, GuardianSnapshot },
  data() {
    return {
      rules: {
        tpage: [
          (v) => !!v || this.$t("rule-required"),
          (v) => v <= this.pageCount || this.$t("rule-out-of-max"),
          (v) => v >= 1 || this.$t("rule-below-min"),
          (v) => Number.isInteger(v) || this.$t("rule-check-integer"),
        ],
      },
      searchSocket: null,
      socketHeartbeat: null,
      licensePlateData: {
        selectedChannelUuids: [],
        selectedCameraUuids: [],
        selectedCameras: [],
        startDate: moment().startOf("day").format("YYYY-MM-DD"),
        startTime: moment().startOf("day").format("HH:mm:ss"),
        endDate: moment().endOf("day").format("YYYY-MM-DD"),
        endTime: moment().endOf("day").format("HH:mm:ss"),
        filterLicensePlates: [],
        listTypes: [],
        plateTypes: [],
        area: null,
        chineseName: null,
        englishName: null,
        company: null,
        department: null,
        employeeNumber: null,
      },
      selected: [],
      selected_licensePlate: null,
      selectedCamerasInput: null,
      filterLicensePlateInput: null,
      page: 1,
      tpage: 1,
      totalCount: 0,
      itemPerPage: 50,
      inferenceCameraItems: [],
      licensePlateItems: [],
      listTypeItems: [
        { text: this.$t("whitelist"), value: "whitelist" },
        { text: this.$t("blacklist"), value: "blacklist" },
        { text: this.$t("VIP"), value: "VIP" },
      ],
      plateTypeItems: [
        { text: this.$t("normal"), value: "normal" },
        { text: this.$t("electric"), value: "electric" },
        { text: this.$t("military"), value: "military" },
        { text: this.$t("diplomatic_mission"), value: "diplomatic_mission" },
        { text: this.$t("foreign_office"), value: "foreign_office" },
      ],
    };
  },
  created() {
    this.init(this);
  },
  beforeDestroy() {
    if (this.searchSocket != null) {
      this.searchSocket.close();
      clearInterval(this.socketHeartbeat);
    }
  },
  watch: {
    licensePlateItems: {
      handler() {
        let selected_licensePlate = this.selected_licensePlate;

        if (selected_licensePlate != null) {
          let check_item = this.licensePlateItems.find(function (item) {
            return item._id == selected_licensePlate._id;
          });
          if (check_item == undefined) {
            this.selected_licensePlate = null;
          }
        }
      },
      deep: true,
    },
    page() {
      if (this.page != null && this.page != "" && Number.isInteger(this.page)) {
        this.tpage = this.page;
        this.changePage({ page: this.page, offset: this.itemPerPage });

        this.selected = [];
      }
    },
  },
  computed: {
    cameraNameItems() {
      return this.inferenceCameraItems.map((item) => item.camera.camera_name);
    },
    likesAllCamera() {
      return (
        this.licensePlateData.selectedCameras.length ===
        this.cameraNameItems.length
      );
    },
    likesSomeCamera() {
      return (
        this.licensePlateData.selectedCameras.length > 0 && !this.likesAllCamera
      );
    },
    selectAllIcon() {
      if (this.likesAllCamera) return "mdi-checkbox-marked";
      if (this.likesSomeCamera) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    pageCount() {
      let pageCount = Math.ceil(this.totalCount / this.itemPerPage);
      return pageCount > 0 ? pageCount : 1;
    },
  },
  methods: {
    random: random,
    translateTime: translateTime,
    getLicensePlateRawImages: getLicensePlateRawImages,
    async init(scope) {
      scope.inferenceCameraItems = await getInferenceCameras();

      return scope;
    },
    getInferenceCamera(inference_camera_uuid) {
      let inferenceCameraItem = this.inferenceCameraItems.find(function (item) {
        return item._id == inference_camera_uuid;
      });

      return inferenceCameraItem;
    },
    resetLicensePlate() {
      this.licensePlateData = {
        startDate: null,
        startTime: null,
        endDate: null,
        endTime: null,
        selectedCameras: [],
        filterLicensePlates: [],
        listTypes: [],
        plateTypes: [],
        area: null,
        chineseName: null,
        englishName: null,
        company: null,
        department: null,
        employeeNumber: null,
      };
    },
    searchLicensePlate(startDate, startTime, endDate, endTime) {
      let licensePlateApi =
        "ws://" +
        this.$store.state.host.ip +
        ":" +
        this.$store.state.host.port +
        "/socket/api/v1/licensePlates";

      let data = {};

      // Check date time setting
      let startTimestamp = null;

      if ((startDate == null) ^ (startTime == null)) {
        this.$store.dispatch("openSnackbar", {
          message: this.$t("timeStartError"),
        });
        return;
      }
      if (startDate != null && startTime != null) {
        startTimestamp = moment(startDate + " " + startTime).valueOf();
      }

      let endTimestamp = null;
      if ((endDate == null) ^ (endTime == null)) {
        this.$store.dispatch("openSnackbar", {
          message: this.$t("timeEndError"),
        });
        return;
      }
      if (endDate != null && endTime != null) {
        endTimestamp = moment(endDate + " " + endTime).valueOf();
      }

      if (startTimestamp == null && endTimestamp != null) {
        this.$store.dispatch("openSnackbar", {
          message: this.$t("timeStartError"),
        });
        return;
      } else if (startTimestamp != null && endTimestamp == null) {
        this.$store.dispatch("openSnackbar", {
          message: this.$t("timeEndError"),
        });
        return;
      }

      if (startTimestamp != null && endTimestamp != null) {
        if (moment(startTimestamp).isAfter(moment(endTimestamp))) {
          this.$store.dispatch("openSnackbar", {
            message: this.$t("timeEarlierError"),
          });
          return;
        }

        startTimestamp = startTimestamp.toString().slice(0, 13);
        endTimestamp = endTimestamp.toString().slice(0, 13);

        data.start_time = parseInt(startTimestamp);
        data.end_time = parseInt(endTimestamp);
      }

      if (this.selectedCamerasInput != null) {
        this.licensePlateData.selectedCameras.push(this.selectedCamerasInput);
        this.selectedCamerasInput = null;
      }

      if (this.licensePlateData.selectedCameras.length > 0) {
        data.selected_cameras = this.licensePlateData.selectedCameras;
      }

      if (this.filterLicensePlateInput != null) {
        this.licensePlateData.filterLicensePlates.push(
          this.filterLicensePlateInput
        );
        this.filterLicensePlateInput = null;
      }

      if (this.licensePlateData.filterLicensePlates.length > 0) {
        for (
          let i = 0;
          i < this.licensePlateData.filterLicensePlates.length;
          i++
        ) {
          this.licensePlateData.filterLicensePlates[i] =
            this.licensePlateData.filterLicensePlates[i].toUpperCase();
        }
        data.filter_license_plates = this.licensePlateData.filterLicensePlates;
      }

      if (this.licensePlateData.listTypes.length > 0) {
        data.list_types = this.licensePlateData.listTypes;
      }

      if (this.licensePlateData.plateTypes.length > 0) {
        data.plate_types = this.licensePlateData.plateTypes;
      }

      if (this.licensePlateData.area != null) {
        data.area = this.licensePlateData.area;
      }

      if (this.licensePlateData.chineseName != null) {
        data.chinese_name = this.licensePlateData.chineseName;
      }

      if (this.licensePlateData.englishName != null) {
        data.english_name = this.licensePlateData.englishName;
      }

      if (this.licensePlateData.company != null) {
        data.company = this.licensePlateData.company;
      }

      if (this.licensePlateData.department != null) {
        data.department = this.licensePlateData.department;
      }

      if (this.licensePlateData.employeeNumber != null) {
        data.employee_number = this.licensePlateData.employeeNumber;
      }

      // Set to first page and set offset
      data.page_no = 1;
      data.page_offset = this.itemPerPage;

      // Cache search data
      this.$store.state.licensePlate.searchCache = data;

      this.page = 1;

      if (this.searchSocket != null) {
        this.searchSocket.close();
        clearInterval(this.socketHeartbeat);
      }

      let licenseSocket = new WebSocket(licensePlateApi);
      this.searchSocket = licenseSocket;
      this.$store.dispatch("openOverlay");
      // on socket connect
      this.searchSocket.onopen = () => {
        window.console.log("Event search socket connection open ...");

        this.socketHeartbeat = setInterval(() => {
          if (this.searchSocket.readyState === 1) {
            this.searchSocket.send("heartBeat");
          }
        }, 10000);

        let message = JSON.stringify(data);
        this.searchSocket.send(message);
      };

      this.searchSocket.onclose = () => {
        window.console.log("Event search socket connection close ...");
      };

      this.searchSocket.onmessage = (licensePlate) => {
        if (licensePlate.data != undefined) {
          let status = JSON.parse(licensePlate.data).status;

          if (status.code == 200) {
            this.licensePlateItems = JSON.parse(
              licensePlate.data
            ).license_plates;
            this.licensePlateItems.forEach((item) => {
              item.license_plates.forEach((plate) => {
                if (!this.$store.state.withDash) {
                  plate.number = plate.number.replace("-", "");
                }
              });
            });

            this.totalCount = JSON.parse(licensePlate.data).total_count;
          } else {
            this.$store.dispatch("openSnackbar", {
              message: status.message,
            });
          }
        } else {
          this.licensePlateItems = [];
        }
        this.$store.dispatch("closeOverlay");
      };
    },
    selectLicensePlate(item) {
      this.selected_licensePlate = item;
    },
    toggleSelectAll() {
      this.$nextTick(() => {
        if (this.likesAllCamera) {
          this.licensePlateData.selectedCameras = [];
        } else {
          this.licensePlateData.selectedCameras = this.cameraNameItems;
        }
      });
    },
    changePage(payload) {
      if (this.searchSocket != null) {
        let data = this.$store.state.licensePlate.searchCache;
        data.page_no = payload.page;
        data.page_offset = payload.offset;

        this.$store.dispatch("openOverlay");
        let message = JSON.stringify(data);
        if (this.searchSocket != null && this.searchSocket.readyState === 1) {
          this.searchSocket.send(message);
        }
      }
    },
    gotoPage(page) {
      if (page < 1 || page > this.pageCount) {
        return;
      }

      if (page != null && page != "" && Number.isInteger(page)) {
        this.page = page;
        this.changePage({ page: page, offset: this.itemPerPage });

        this.selected = [];
      }
    },
  },
};
</script>
